const settingsDefaults = {
    NUMBER_OF_WORK_SESSIONS_BEFORE_LONG_BREAK: 4
};

export default settingsDefaults;


// WEBPACK FOOTER //
// ./src/constants/SettingsDefaults.js